import {
    FEATURE_FLAGS,
    FeatureFlagConfig,
} from '../models/feature-flag-config.model';

class FeatureFlagsHelper {
    private static instance: FeatureFlagsHelper;
    private flags: FeatureFlagConfig | null = null;

    private constructor(data: FeatureFlagConfig) {
        this.flags = data;
    }

    // Initialize the singleton instance
    public static init(data: FeatureFlagConfig) {
        if (!FeatureFlagsHelper.instance) {
            FeatureFlagsHelper.instance = new FeatureFlagsHelper(data);
        }
    }

    // Get the singleton instance
    public static getInstance(): FeatureFlagsHelper {
        if (!FeatureFlagsHelper.instance) {
            throw new Error(
                'FeatureFlags not initialized. Call FeatureFlagsHelper.init(apiUrl) first.',
            );
        }
        return FeatureFlagsHelper.instance;
    }

    // Get the value of a specific feature flag
    public hasFlag(flagName: FEATURE_FLAGS): boolean | undefined {
        if (!this.flags) {
            throw new Error('Feature flags have not been fetched yet.');
        }
        return !!this.flags[flagName];
    }

    // Get the value of a specific feature flag
    public getFlag(
        flagName: FEATURE_FLAGS,
    ): boolean | string | number | number[] | string[] | undefined {
        if (!this.flags) {
            throw new Error('Feature flags have not been fetched yet.');
        }
        return this.flags[flagName];
    }
}

export default FeatureFlagsHelper;
